// Счетчик цифр на главной странице
const section_counter = document.querySelector('.jumbotron-count')

if (section_counter) {
  const counters = section_counter.querySelectorAll('.count')
  // Scroll Animation
  const counterObserver = new IntersectionObserver(
    (entries, observer) => {
      let [entry] = entries
      if (!entry.isIntersecting) return

      let speed = 50
      counters.forEach((counter, index) => {
        const targetNumber = +counter.dataset.target
        // Find the unit for one counter step
        const count = targetNumber / speed
        // Set data attribute for accurate calculation with decimal
        counter.setAttribute('data-count', 0)

        function UpdateCounter() {
          const initialNumber = Number(counter.innerText.replaceAll(/\s+/g, ''))
          // Get decimal number to calculate
          const countNumber = +counter.dataset.count
          // Getting an integer value with Math.floor()
          const integer = Math.floor(countNumber)
          if (initialNumber < targetNumber) {
            // Set decimal number / toFixed() with speed length, to increase accuracy
            counter.setAttribute('data-count', (countNumber + count).toFixed(`${speed}`.length))
            // Set integer number
            counter.innerText = integer.toLocaleString('ru-RU')
            setTimeout(UpdateCounter, 50)
          } else {
            // remove additional data attribute
            counter.removeAttribute('data-count')
          }
        }

        UpdateCounter()

        if (counter.parentElement.style.animation) {
          counter.parentElement.style.animation = ''
        } else {
          counter.parentElement.style.animation = `slide-up 0.3s ease forwards ${index / counters.length + 0.5}s`
        }
      })
      observer.unobserve(section_counter)
    },
    {
      root: null,
      threshold: window.innerWidth > 768 ? 0.4 : 0.3,
    }
  )
  window.onload = function () {
    counterObserver.observe(section_counter)
  }
}
